import React from 'react';
import AllCourses from '../AllCourses/AllCourses';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

const ShoingAllCourses = () => {
    return (
        <div>
            <Header></Header>
            <AllCourses></AllCourses>
            <Footer></Footer>
        </div>
    );
};

export default ShoingAllCourses;